export default "__VITE_ASSET__2be789e3__"